module.exports = __webpack_public_path__ + "img/AXIS_Favicon_green_142x142.5a010fc5.png";